/**
 * HQ 점주 가입 승인 서비스.
 *
 * 백엔드는 backend/api/admin_owner.py 다.
 * 같은 주소를 domains/admin/api/owner_approval_api.py 도 선언하지만 뒤에 등록돼
 * 가려지므로 실제로 응답하는 쪽은 admin_owner.py 다. 응답 필드도 그쪽 기준.
 */
import hqApi from './hqApiClient';

export interface HqSignupRegistration {
  id: string;
  organization_name: string;
  business_registration_number: string | null;
  address: string | null;
  phone: string | null;
  owner_name: string;
  owner_email: string;
  owner_phone: string;
  submitted_at: string | null;
  approved_at?: string | null;
  rejection_reason?: string | null;
  /** 승인 창 요금 기본값(정가·할인) — 서버 계산(2026-10-28) */
  price?: { list_price: number; discount_amount: number; discount_label: string | null } | null;
}

const toRegistration = (r: any): HqSignupRegistration => ({
  id: r.id,
  organization_name: r.name,
  business_registration_number: r.business_registration_number,
  address: r.address,
  phone: r.phone,
  owner_name: r.owner_name,
  owner_email: r.owner_email,
  owner_phone: r.owner_phone,
  submitted_at: r.created_at,
  approved_at: r.approved_at,
  rejection_reason: r.rejection_reason,
  price: r.price,
});

const BASE = '/api/v1/admin/owner-approvals';

export const hqSignupService = {
  async list(kind: 'pending' | 'approved' | 'rejected'): Promise<HqSignupRegistration[]> {
    const { data } = await hqApi.get<any[]>(`${BASE}/${kind}`);
    return (data || []).map(toRegistration);
  },

  async pendingCount(): Promise<number> {
    const items = await hqSignupService.list('pending');
    return items.length;
  },

  /** 승인 + 매장 구독 요금(정가·할인 후 월액·할인 이름, 2026-10-28) */
  async approve(
    organizationId: string,
    price?: { list_price: number; monthly_fee: number; discount_label: string | null },
  ): Promise<void> {
    await hqApi.post(`${BASE}/${organizationId}/approve`, price);
  },

  async reject(organizationId: string, reason: string): Promise<void> {
    await hqApi.post(`${BASE}/${organizationId}/reject`, {
      rejection_reason: reason,
    });
  },
};

export default hqSignupService;
